module.exports = __webpack_public_path__ + "img/inactiveicon-relationship_chart_icon.23817f4c.svg";